import React, { useEffect, useState } from "react";

import Header from "../../components/header";
import Footer from "../../components/footer";
import BackToTopButton from "../../components/back-to-top";
import {
  MODEL_TYPE_CAREER,
  PERSONALITY_TEST_ASSESSMENT_ID,
} from "../../utils/general-config";
import { useLocation, useParams } from "react-router-dom";
import Loader from "../../components/loader";
import {
  getBannerImage,
  getCareerBannerImage,
  getColorCode,
  getCookie,
  getImage,
} from "../../utils/utility-functions";

import { LOCALE } from "../../utils/constants";
import { useTranslation } from "react-i18next";
import ShareButton from "../../components/share-button";
import SendToFriendButton from "../../components/send-to-friend-button";

const CareerReport = ({
  getAssessmentAttemptByUserIdConnect,
  funnelStep,
  getInsightfulContentConnect,
  getUserByIdConnect,
  sendToFriendReportOnEmailConnect,
}) => {
  const [assessmentAttemptData, setAssessmentAttemptData] = useState({});
  const { userGUID, gender, isAuth } = funnelStep || {};
  // const token = getCookie("jwtToken");
  const { t } = useTranslation();
  const [mobileMenuActive, setMobileMenuActive] = useState(false);
  const [insightfulContent, setInsightfulContent] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const [userData, setUserData] = useState(null);
  const queryParams = new URLSearchParams(location.search);
  const traitCode = queryParams.get("code");
  const assessmentAttemptId = queryParams.get("aai");
  const userId = queryParams.get("uid") || userGUID;
  const { locale } = useParams();
  const currentLocale = locale ?? LOCALE.EN;
  const pathSegments = location.pathname.split("/");
  const reportType = pathSegments[4];

  const [currentAssessmentAttemptData, setCurrentAssessmentAttemptData] =
    useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [isLoading]);

  useEffect(() => {
    if (userId) {
      setIsLoading(true);
      const data = {
        modelType:
          MODEL_TYPE_CAREER[currentLocale] || MODEL_TYPE_CAREER[LOCALE.EN],
        contentKey: traitCode,
      };
      getInsightfulContentConnect(data)
        .then((response) => {
          setInsightfulContent(response);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [userId]);

  useEffect(() => {
    if (userId) {
      getUserByIdConnect(userId).then((res) => {
        if (res) {
          setUserData(res);
        }
      });
      getAssessmentAttemptByUserIdConnect(userId, currentLocale).then(
        (response) => {
          const filterByCurrentAssessmentAttemptId = response.filter(
            (item) => item.assessmentAttemptId === assessmentAttemptId
          );

          setCurrentAssessmentAttemptData(filterByCurrentAssessmentAttemptId);
          const filterLatestPersonalityData = response
            .filter((item) => {
              return (
                item.assessmentId === PERSONALITY_TEST_ASSESSMENT_ID &&
                item.personality !== null
              );
            })
            ?.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn)) // Sort by createdOn in descending order
            ?.map((item, index) => {
              if (index === 0) {
                return item;
              }
            })
            ?.filter(Boolean)[0];

          // Set the assessment attempt data
          setAssessmentAttemptData(filterLatestPersonalityData);

          // Filter the latest personality data
        }
      );
    }
  }, [getAssessmentAttemptByUserIdConnect, userId]);

  const createSectionHeader = (title, gradientColors, imageSrc) => {
    return (
      <div
        className={`relative min-h-[12rem] sm:h-64 bg-gradient-to-r ${gradientColors} flex items-center px-4 sm:px-8`}
      >
        <img
          src={imageSrc}
          alt={title}
          className="absolute bottom-0 right-0 w-full md:w-2/3 h-auto md:h-full object-cover object-right"
        />
        <div
          className={`absolute inset-0 bg-gradient-to-r ${gradientColors} to-transparent opacity-65`}
        ></div>
        <div className="relative z-10 max-w-[90%] px-4 sm:px-0 py-4 sm:py-0">
          <h2 className="text-4xl sm:text-4xl font-bold mb-2 shadow-text break-words text-white">
            {title}
          </h2>
        </div>
      </div>
    );
  };
  const personalityGroup = assessmentAttemptData
    ? assessmentAttemptData?.personality?.role
    : "";
  const personalityName = assessmentAttemptData
    ? assessmentAttemptData?.personality?.name
    : "";
  const currentPersonalityGroup = currentAssessmentAttemptData
    ? currentAssessmentAttemptData[0]?.personality?.role
    : "";
  const currentPersonalityName = currentAssessmentAttemptData
    ? currentAssessmentAttemptData[0]?.nameEnglishCode
    : "";
  const personalityColorDark = getColorCode(
    currentPersonalityGroup && currentPersonalityGroup
  ).dark;

  const bannerImage = getBannerImage(currentPersonalityGroup);
  const personalityImage = getImage(
    currentPersonalityGroup,
    currentPersonalityName,
    true,
    gender || userData?.gender
  );

  if (isLoading) {
    return (
      <div>
        {" "}
        <Loader isLoading={isLoading} />
      </div>
    );
  }

  return (
    <>
      <Header
        personalityGroup={
          personalityGroup ? personalityGroup.toLowerCase() : ""
        }
        personalityName={personalityName ? personalityName.toLowerCase() : ""}
      />
      <BackToTopButton />
      <div className="bg-gray-100">
        <header className="container mx-auto p-2">
          <div
            className="relative h-64 sm:h-96 bg-gradient-to-r"
            id={reportType}
          >
            <img
              src={bannerImage}
              alt={insightfulContent?.content?.Title}
              className="absolute inset-0 w-full h-full object-cover object-center"
            />
            <div
              className="absolute inset-0 flex items-center justify-between"
              id={reportType}
            >
              <div className="w-full sm:w-3/5 pl-8">
                <h1 className="text-4xl md:text-4xl font-bold mb-2 shadow-text text-white">
                  {insightfulContent && insightfulContent?.content?.Title} (
                  {insightfulContent && insightfulContent?.content?.Code})
                </h1>
                <h4
                  className="text-xl lg:text-3xl font-light shadow-text text-white"
                  id={reportType}
                >
                  {insightfulContent?.content?.Group} in{" "}
                  {insightfulContent?.content?.Industry}
                </h4>
              </div>
              <div
                className="hidden sm:block w-max h-full aspect-square"
                id={reportType}
              >
                <img
                  src={personalityImage}
                  alt={insightfulContent?.content?.Title}
                  className="w-auto h-full object-bottom float-right md:-mr-0 ml-10 mb-0"
                />
              </div>
            </div>
          </div>
          <nav
            className={`p-4 z-0`}
            style={{ backgroundColor: personalityColorDark }}
          >
            <button
              id="mobile-menu-button"
              className="lg:hidden hover:text-yellow-300 transition-colors"
              onClick={() => setMobileMenuActive(!mobileMenuActive)}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                ></path>
              </svg>
            </button>

            <ul
              id="nav-menu"
              className={`flex flex-col lg:flex-row justify-center gap-4 ${
                mobileMenuActive ? "block" : "hidden lg:flex"
              }`}
            >
              <li>
                <a
                  href="#introduction"
                  className="text-white hover:text-yellow-300 transition-colors"
                >
                  {t("report.career_test.introduction")}
                </a>
              </li>
              <li>
                <a
                  href="#why"
                  className="text-white hover:text-yellow-300 transition-colors"
                >
                  {t("report.career_test.why")}
                </a>
              </li>
              <li>
                <a
                  href="#workplace"
                  className="text-white hover:text-yellow-300 transition-colors"
                >
                  {t("report.career_test.workplace")}
                </a>
              </li>
              <li>
                <a
                  href="#industry-work"
                  className="text-white hover:text-yellow-300 transition-colors"
                >
                  {t("report.career_test.industry_work")}
                </a>
              </li>
              <li>
                <a
                  href="#niche"
                  className="text-white hover:text-yellow-300 transition-colors"
                >
                  {t("report.career_test.niche")}
                </a>
              </li>
              <li>
                <a
                  href="#environment"
                  className="text-white hover:text-yellow-300 transition-colors"
                >
                  {t("report.career_test.environment")}
                </a>
              </li>
              <li>
                <a
                  href="#challenges"
                  className="text-white hover:text-yellow-300 transition-colors"
                >
                  {t("report.career_test.challenges")}
                </a>
              </li>
              <li>
                <a
                  href="#equip"
                  className="text-white hover:text-yellow-300 transition-colors"
                >
                  {t("report.career_test.equip")}
                </a>
              </li>
              <li>
                <a
                  href="#conclusion"
                  className="text-white hover:text-yellow-300 transition-colors"
                >
                  {t("report.career_test.conclusion")}
                </a>
              </li>
              <li>
                <a
                  href="#faq"
                  className="text-white hover:text-yellow-300 transition-colors"
                >
                  {t("report.career_test.faq")}
                </a>
              </li>
            </ul>
          </nav>
        </header>
        <div id="content" className="container mx-auto p-2">
          {/* {----------------------------INTRO SECTION------------------------------------} */}
          {isAuth && (
            <div className="w-full mb-1 pt-[10px] flex justify-end lg:justify-end gap-[10px] lg:px-6">
              <ShareButton
                currentAssessmentAttemptData={currentAssessmentAttemptData[0]}
                userGUID={userId}
                userData={userData}
              />
              <SendToFriendButton
                currentAssessmentAttemptData={currentAssessmentAttemptData[0]}
                userGUID={userGUID}
                userData={userData}
                CreateGuestUserConnect={sendToFriendReportOnEmailConnect}
              />
            </div>
          )}
          <section
            className="bg-white rounded-xl shadow-lg overflow-hidden mb-8"
            id="introduction"
          >
            {createSectionHeader(
              insightfulContent &&
                insightfulContent?.content?.Intro?.RootHeading,
              "from-blue-500 via-blue-600 to-indigo-700",
              getCareerBannerImage("introduction")
            )}
            <div className="p-6 sm:p-10">
              <p className="text-lg text-gray-700 leading-relaxed">
                {insightfulContent &&
                  insightfulContent?.content?.Intro?.Content}
              </p>
            </div>
          </section>
          {/* {----------------------------WHY INDUSTRY SECTION------------------------------------} */}
          <section
            className="bg-white rounded-xl shadow-lg overflow-hidden mb-8"
            id="why"
          >
            {createSectionHeader(
              insightfulContent &&
                insightfulContent?.content?.Why_industry?.RootHeading,
              "from-blue-500 via-blue-600 to-indigo-700",
              getCareerBannerImage("why")
            )}
            <div className="p-6 sm:p-10">
              <p className="text-lg text-gray-700 leading-relaxed">
                {insightfulContent &&
                  insightfulContent?.content?.Why_industry?.Content}
              </p>
            </div>
          </section>
          {/* {----------------------------WHY WORKPLACE SECTION------------------------------------} */}
          <section
            className="bg-white rounded-xl shadow-lg overflow-hidden mb-8"
            id="workplace"
          >
            {createSectionHeader(
              insightfulContent &&
                insightfulContent?.content?.Workplace?.RootHeading,
              "from-blue-500 via-blue-600 to-indigo-700",
              getCareerBannerImage("workplace")
            )}
            <div className="p-6 sm:p-10 flex flex-col gap-6">
              <p className="text-lg text-gray-700 leading-relaxed">
                {insightfulContent &&
                  insightfulContent?.content?.Workplace?.Content_Flavor_Text}
              </p>
              {insightfulContent &&
                insightfulContent?.content?.Workplace?.Content.map(
                  (item, index) => (
                    <div
                      key={index}
                      className="mb-6 bg-blue-50 rounded-lg p-6 shadow-md"
                    >
                      <h3 className="text-2xl font-bold mb-4 text-blue-800">
                        {item.Heading}
                      </h3>
                      <p className="text-lg text-gray-700 leading-relaxed">
                        {item.Description}
                      </p>
                    </div>
                  )
                )}
            </div>
          </section>
          {/* {---------------------------INDUSTRY SECTION------------------------------------} */}
          <section
            className="bg-white rounded-xl shadow-lg overflow-hidden mb-8"
            id="industry-work"
          >
            {createSectionHeader(
              insightfulContent &&
                insightfulContent?.content?.Role_Industry?.RootHeading,
              "from-blue-500 via-blue-600 to-indigo-700",
              getCareerBannerImage("industry-work")
            )}
            <div className="p-6 sm:p-10 flex flex-col gap-6">
              <p className="text-lg text-gray-700 leading-relaxed">
                {insightfulContent &&
                  insightfulContent?.content?.Role_Industry
                    ?.Content_Flavor_Text}
              </p>
              {insightfulContent &&
                insightfulContent?.content?.Role_Industry?.Content.map(
                  (item, index) => (
                    <div
                      key={index}
                      className="mb-6 bg-blue-50 rounded-lg p-6 shadow-md"
                    >
                      <h3 className="text-2xl font-bold mb-4 text-blue-800">
                        {item.Heading}
                      </h3>
                      <p className="text-lg text-gray-700 leading-relaxed">
                        {item.Description}
                      </p>
                    </div>
                  )
                )}
            </div>
          </section>
          {/* {---------------------------NICHE SECTION------------------------------------} */}
          <section
            className="bg-white rounded-xl shadow-lg overflow-hidden mb-8"
            id="niche"
          >
            {createSectionHeader(
              insightfulContent &&
                insightfulContent?.content?.Niche?.RootHeading,
              "from-blue-500 via-blue-600 to-indigo-700",
              getCareerBannerImage("niche")
            )}
            <div className="p-6 sm:p-10 flex flex-col gap-6">
              <p className="text-lg text-gray-700 leading-relaxed">
                {insightfulContent &&
                  insightfulContent?.content?.Niche?.Content_Flavor_Text}
              </p>
              {insightfulContent &&
                insightfulContent?.content?.Niche?.Content.map(
                  (item, index) => (
                    <div
                      key={index}
                      className="mb-6 bg-blue-50 rounded-lg p-6 shadow-md"
                    >
                      <h3 className="text-2xl font-bold mb-4 text-blue-800">
                        {item.Heading}
                      </h3>
                      <p className="text-lg text-gray-700 leading-relaxed">
                        {item.Description}
                      </p>
                    </div>
                  )
                )}
            </div>
          </section>
          {/* {---------------------------ENVIRONMENT SECTION------------------------------------} */}
          <section
            className="bg-white rounded-xl shadow-lg overflow-hidden mb-8"
            id="environment"
          >
            {createSectionHeader(
              insightfulContent &&
                insightfulContent?.content?.Environment?.RootHeading,
              "from-blue-500 via-blue-600 to-indigo-700",
              getCareerBannerImage("environment")
            )}
            <div className="p-6 sm:p-10 flex flex-col gap-6">
              <p className="text-lg text-gray-700 leading-relaxed">
                {insightfulContent &&
                  insightfulContent?.content?.Environment?.Content_Flavor_Text}
              </p>
              {insightfulContent &&
                insightfulContent?.content?.Environment?.Content.map(
                  (item, index) => (
                    <div
                      key={index}
                      className="mb-6 bg-blue-50 rounded-lg p-6 shadow-md"
                    >
                      <h3 className="text-2xl font-bold mb-4 text-blue-800">
                        {item.Heading}
                      </h3>
                      <p className="text-lg text-gray-700 leading-relaxed">
                        {item.Description}
                      </p>
                    </div>
                  )
                )}
            </div>
          </section>
          {/* {---------------------------CHALLENGES SECTION------------------------------------} */}
          <section
            className="bg-white rounded-xl shadow-lg overflow-hidden mb-8"
            id="challenges"
          >
            {createSectionHeader(
              insightfulContent &&
                insightfulContent?.content?.Challenges?.RootHeading,
              "from-blue-500 via-blue-600 to-indigo-700",
              getCareerBannerImage("challenges")
            )}
            <div className="p-6 sm:p-10 flex flex-col gap-6">
              <p className="text-lg text-gray-700 leading-relaxed">
                {insightfulContent &&
                  insightfulContent?.content?.Challenges?.Content_Flavor_Text}
              </p>
              {insightfulContent &&
                insightfulContent?.content?.Challenges?.Content.map(
                  (item, index) => (
                    <div
                      key={index}
                      className="mb-6 bg-blue-50 rounded-lg p-6 shadow-md"
                    >
                      <h3 className="text-2xl font-bold mb-4 text-blue-800">
                        {item.Heading}
                      </h3>
                      <p className="text-lg text-gray-700 leading-relaxed">
                        {item.Description}
                      </p>
                    </div>
                  )
                )}
            </div>
          </section>
          {/* {---------------------------EQUIP SECTION------------------------------------} */}
          <section
            className="bg-white rounded-xl shadow-lg overflow-hidden mb-8"
            id="equip"
          >
            {createSectionHeader(
              insightfulContent &&
                insightfulContent?.content?.Equip?.RootHeading,
              "from-blue-500 via-blue-600 to-indigo-700",
              getCareerBannerImage("equip")
            )}
            <div className="p-6 sm:p-10 flex flex-col gap-6">
              <p className="text-lg text-gray-700 leading-relaxed">
                {insightfulContent &&
                  insightfulContent?.content?.Equip?.Content_Flavor_Text}
              </p>
              {insightfulContent &&
                insightfulContent?.content?.Equip?.Content.map(
                  (item, index) => (
                    <div
                      key={index}
                      className="mb-6 bg-blue-50 rounded-lg p-6 shadow-md"
                    >
                      <h3 className="text-2xl font-bold mb-4 text-blue-800">
                        {item.Heading}
                      </h3>
                      <p className="text-lg text-gray-700 leading-relaxed">
                        {item.Description}
                      </p>
                    </div>
                  )
                )}
            </div>
          </section>
          {/* {---------------------------CONCLUSION SECTION------------------------------------} */}
          <section
            className="bg-white rounded-xl shadow-lg overflow-hidden mb-8"
            id="conclusion"
          >
            {createSectionHeader(
              insightfulContent &&
                insightfulContent?.content?.Conclusion?.RootHeading,
              "from-blue-500 via-blue-600 to-indigo-700",
              getCareerBannerImage("conclusion")
            )}
            <div className="p-6 sm:p-10">
              <p className="text-lg text-gray-700 leading-relaxed">
                {insightfulContent &&
                  insightfulContent?.content?.Conclusion?.Content}
              </p>
            </div>
          </section>
          {/* {---------------------------FAQ SECTION------------------------------------} */}
          <section
            className="bg-white rounded-xl shadow-lg overflow-hidden mb-8"
            id="faq"
          >
            {createSectionHeader(
              insightfulContent && insightfulContent?.content?.FAQ?.RootHeading,
              "from-blue-500 via-blue-600 to-indigo-700",
              getCareerBannerImage("faq")
            )}
            <div className="p-6 sm:p-10">
              <p className="text-lg text-gray-700 leading-relaxed">
                {insightfulContent &&
                  insightfulContent?.content?.FAQ?.Content.map(
                    (item, index) => (
                      <div
                        key={index}
                        className="mb-6 bg-blue-50 rounded-lg p-6 shadow-md"
                      >
                        <h3 className="text-2xl font-bold mb-4 text-blue-800">
                          {item.Question}
                        </h3>
                        <p className="text-lg text-gray-700 leading-relaxed">
                          {item.Answer}
                        </p>
                      </div>
                    )
                  )}
              </p>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CareerReport;
